module.exports = __webpack_public_path__ + "fonts/Rubik-400-latin-ext68.15c3dca.woff2";